import { DrEntity } from './dr-entity';
import { DrObjectType, DrObject } from './dr-object';
import { TagScope, TagState } from './enums';
import { ViewType } from './view';

export class TagViewModel extends DrObject {
    model: Partial<Tag>;
    constructor(value?: Partial<Tag>) {
        super(DrObjectType.TAG);
        if (value) {
            this.model = value;
        }
    }
}

export class Tag extends DrEntity {
    name: string;
    description: string;
    createdBy: string;
    displayValue: string;
    enabled: boolean;
    iconClass = `fa-tag`;
    iconColor: string;
    hasReservedWords = true;
    selected: boolean;
    ownerHandle = null;
    documentCount: number;
    viewType: ViewType;

    constructor(value?: Partial<Tag>) {
        super(value);
        if (value) {
            if (value.viewType === ViewType.TAG) {
                for (let attr of value?.attributes) {
                    if (attr.name === 'displayValue') {
                        this.iconColor = value.displayValue = attr.value.toLocaleUpperCase();
                    } else if (attr.name === 'tagHandle') {
                        value.handle = attr.value;
                    }
                }
            } else {
                this.iconColor = value.displayValue;
            }
            Object.assign(this, value);
        }
    }
}

export class TagApplication {
    tagHandle: string;
    tagState: TagState;
    sttagState: string;

    constructor(value: Partial<TagApplication>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class TagQueueApplication {
    tagHandle: string;
    tagState: TagState;
    tagName: string;
    displayValue: string;

    constructor(value: Partial<TagQueueApplication>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class TagDocumentsOperation {
    handles: Array<string>;
    comment: string;
    tagList: Array<TagApplication>;
    scope: TagScope;
    suppressDuplicates: boolean;

    constructor(value: Partial<TagDocumentsOperation>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class TagQueueItem {
    documentHandle: string;
    documentNumber: string;
    documentNumberTooltip: string;
    tagList: Array<TagQueueApplication>;
    isButtonVisible = true;
    isButtonEnabled = true;
    buttonIconClass = 'fa-trash';
    buttonIconColor = 'color-grey-10';

    constructor(value: Partial<TagQueueItem>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}
